import * as PROMOTION_END_POINTS from "../constants/endpoints/promotion";
import axios from "../axios/axios";

export const getMechanicPromotions = () => {
  return axios({
    url: PROMOTION_END_POINTS.GET_MECHANIC_PROMOTIONS,
    method: "GET",
  });
};

export const getMechanicBanners = () => {
  return axios({
    url: PROMOTION_END_POINTS.GET_MECHANIC_BANNERS,
    method: "GET",
  });
};
